import { computed } from 'vue'
import type { CopilotState } from './state'

export const createGetters = (state: CopilotState) => {
  const selectedItems = computed(() =>
    state.contextItems.filter((item) => state.selectedItemIds.includes(item.id))
  )

  const contextSummary = computed(() => {
    const selected = selectedItems.value
    if (selected.length === 0) return 'Sin contexto seleccionado'

    const counts: Record<string, number> = {}
    selected.forEach((item) => {
      const label =
        item.type === 'document'
          ? 'documentos'
          : item.type === 'attachment'
            ? 'adjuntos'
            : item.type === 'application'
              ? 'aplicaciones'
              : item.type === 'requirement'
                ? 'requerimientos'
                : 'reuniones'
      counts[label] = (counts[label] || 0) + 1
    })

    return Object.entries(counts)
      .map(([label, count]) => `${count} ${label}`)
      .join(', ')
  })

  const projectStats = computed(() => {
    const items = state.contextItems
    const reqs = items.filter((i) => i.type === 'requirement')
    const meetings = items.filter((i) => i.type === 'meeting')
    const apps = items.filter((i) => i.type === 'application')
    const docs = items.filter((i) => i.type === 'document')

    return {
      totalReqs: reqs.length,
      totalApps: apps.length,
      totalMeetings: meetings.length,
      totalDocs: docs.length,
    }
  })

  const availableItemsByType = computed(() => {
    const grouped: Record<string, typeof state.contextItems> = {
      document: [],
      attachment: [],
      application: [],
      requirement: [],
      meeting: [],
    }
    state.contextItems.forEach((item) => {
      if (grouped[item.type]) {
        grouped[item.type].push(item)
      }
    })
    return grouped
  })

  const totalSelectedTokenEstimate = computed(() => {
    const selected = selectedItems.value
    let totalChars = 0
    selected.forEach((item) => {
      totalChars += (item.content?.length || 0) + (item.summary?.length || 0)
    })
    // Rough estimate: ~4 chars per token
    return Math.ceil(totalChars / 4)
  })

  const isContextReady = computed(
    () => state.selectedProjectId !== null && state.selectedItemIds.length > 0
  )

  return {
    selectedItems,
    contextSummary,
    projectStats,
    availableItemsByType,
    totalSelectedTokenEstimate,
    isContextReady,
  }
}
